import { render, staticRenderFns } from "./CardPagination.vue?vue&type=template&id=2bffbd69"
import script from "./CardPagination.vue?vue&type=script&lang=ts"
export * from "./CardPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bffbd69')) {
      api.createRecord('2bffbd69', component.options)
    } else {
      api.reload('2bffbd69', component.options)
    }
    module.hot.accept("./CardPagination.vue?vue&type=template&id=2bffbd69", function () {
      api.rerender('2bffbd69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardPagination.vue"
export default component.exports